import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, list_type, bool_type, option_type, class_type, int32_type, record_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { UTC$reflection } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { InvoiceeDetails, InvoiceeTerminationState$reflection, InvoiceeBlock$reflection, InvoiceeDetails$reflection } from "../../Containers/Invoicee/Common.js";
import { LoadState_map, LoadState$2, LoadState$2$reflection } from "../../Global.js";
import { InvoiceeState$reflection as InvoiceeState$reflection_1 } from "../../DomainTypes.js";
import { createReducer, createAction } from "../Redux.js";
import { map } from "../../fable_modules/fable-library.3.7.20/Option.js";

export class FeeAttribute extends Record {
    constructor(Name, Value) {
        super();
        this.Name = Name;
        this.Value = Value;
    }
}

export function FeeAttribute$reflection() {
    return record_type("Redux.Reducers.Invoicee.FeeAttribute", [], FeeAttribute, () => [["Name", string_type], ["Value", string_type]]);
}

export class FeeDTO extends Record {
    constructor(FeeNr, InvoiceeNr, ContractNr, AmountExclVat, VatPercentage, Description, AccountNo, BoundMonths, NoNextInvoice, CancellationPeriodMonths, MonthsInAdvance, Type, StartDate, FeeTemplateNr, FinalInvoiceSent, BilledTo, EndDate, CreatedByUserId, CreatedAt, CancelledDate, CancelledByUserIdby, CancelledAt, Attributes, Units, UnitPrice, BoundToDate) {
        super();
        this.FeeNr = (FeeNr | 0);
        this.InvoiceeNr = InvoiceeNr;
        this.ContractNr = ContractNr;
        this.AmountExclVat = AmountExclVat;
        this.VatPercentage = VatPercentage;
        this.Description = Description;
        this.AccountNo = (AccountNo | 0);
        this.BoundMonths = (BoundMonths | 0);
        this.NoNextInvoice = NoNextInvoice;
        this.CancellationPeriodMonths = (CancellationPeriodMonths | 0);
        this.MonthsInAdvance = (MonthsInAdvance | 0);
        this.Type = Type;
        this.StartDate = StartDate;
        this.FeeTemplateNr = FeeTemplateNr;
        this.FinalInvoiceSent = FinalInvoiceSent;
        this.BilledTo = BilledTo;
        this.EndDate = EndDate;
        this.CreatedByUserId = (CreatedByUserId | 0);
        this.CreatedAt = CreatedAt;
        this.CancelledDate = CancelledDate;
        this.CancelledByUserIdby = CancelledByUserIdby;
        this.CancelledAt = CancelledAt;
        this.Attributes = Attributes;
        this.Units = (Units | 0);
        this.UnitPrice = UnitPrice;
        this.BoundToDate = BoundToDate;
    }
}

export function FeeDTO$reflection() {
    return record_type("Redux.Reducers.Invoicee.FeeDTO", [], FeeDTO, () => [["FeeNr", int32_type], ["InvoiceeNr", option_type(class_type("System.Int64"))], ["ContractNr", option_type(int32_type)], ["AmountExclVat", class_type("System.Decimal")], ["VatPercentage", class_type("System.Decimal")], ["Description", string_type], ["AccountNo", int32_type], ["BoundMonths", int32_type], ["NoNextInvoice", bool_type], ["CancellationPeriodMonths", int32_type], ["MonthsInAdvance", int32_type], ["Type", string_type], ["StartDate", class_type("System.DateOnly")], ["FeeTemplateNr", option_type(int32_type)], ["FinalInvoiceSent", bool_type], ["BilledTo", option_type(class_type("System.DateOnly"))], ["EndDate", option_type(class_type("System.DateOnly"))], ["CreatedByUserId", int32_type], ["CreatedAt", UTC$reflection()], ["CancelledDate", option_type(class_type("System.DateOnly"))], ["CancelledByUserIdby", option_type(int32_type)], ["CancelledAt", option_type(UTC$reflection())], ["Attributes", list_type(FeeAttribute$reflection())], ["Units", int32_type], ["UnitPrice", class_type("System.Decimal")], ["BoundToDate", option_type(class_type("System.DateOnly"))]]);
}

export class InvoiceeState extends Record {
    constructor(InvoiceeDetails, InvoiceeFees, InvoiceeBlock, InvoiceeTerminationState) {
        super();
        this.InvoiceeDetails = InvoiceeDetails;
        this.InvoiceeFees = InvoiceeFees;
        this.InvoiceeBlock = InvoiceeBlock;
        this.InvoiceeTerminationState = InvoiceeTerminationState;
    }
}

export function InvoiceeState$reflection() {
    return record_type("Redux.Reducers.Invoicee.InvoiceeState", [], InvoiceeState, () => [["InvoiceeDetails", LoadState$2$reflection(option_type(InvoiceeDetails$reflection()), string_type)], ["InvoiceeFees", LoadState$2$reflection(list_type(FeeDTO$reflection()), string_type)], ["InvoiceeBlock", LoadState$2$reflection(list_type(InvoiceeBlock$reflection()), string_type)], ["InvoiceeTerminationState", LoadState$2$reflection(InvoiceeTerminationState$reflection(), string_type)]]);
}

export class InvoiceeAction extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SetInvoiceeDetails", "SetInvoiceeFees", "SetInvoiceeCurrentState", "SetInvoiceeBlock", "SetInvoiceeTerminationState"];
    }
}

export function InvoiceeAction$reflection() {
    return union_type("Redux.Reducers.Invoicee.InvoiceeAction", [], InvoiceeAction, () => [[["Item", LoadState$2$reflection(option_type(InvoiceeDetails$reflection()), string_type)]], [["Item", LoadState$2$reflection(list_type(FeeDTO$reflection()), string_type)]], [["Item", InvoiceeState$reflection_1()]], [["Item", LoadState$2$reflection(list_type(InvoiceeBlock$reflection()), string_type)]], [["Item", LoadState$2$reflection(InvoiceeTerminationState$reflection(), string_type)]]]);
}

export function setInvoiceeDetails(payload) {
    return createAction("InvoiceeReducer", new InvoiceeAction(0, payload));
}

export function setInvoiceeFees(payload) {
    return createAction("InvoiceeReducer", new InvoiceeAction(1, payload));
}

export function setInvoiceeCurrentState(payload) {
    return createAction("InvoiceeReducer", new InvoiceeAction(2, payload));
}

export function setInvoiceeBlock(payload) {
    return createAction("InvoiceeReducer", new InvoiceeAction(3, payload));
}

export function setInvoiceeTerminationState(payload) {
    return createAction("InvoiceeReducer", new InvoiceeAction(4, payload));
}

export const initState = new InvoiceeState(new LoadState$2(0), new LoadState$2(0), new LoadState$2(0), new LoadState$2(0));

function innerReducer(state, action) {
    switch (action.tag) {
        case 1: {
            return new InvoiceeState(state.InvoiceeDetails, action.fields[0], state.InvoiceeBlock, state.InvoiceeTerminationState);
        }
        case 2: {
            return new InvoiceeState(LoadState_map((option) => map((invoiceeDetails) => (new InvoiceeDetails(invoiceeDetails.Address, invoiceeDetails.BilledTo, invoiceeDetails.ClientContactReference, invoiceeDetails.ClientCrossRef, invoiceeDetails.ContactPhoneNumber, invoiceeDetails.ContractNumbers, invoiceeDetails.CountryCode, invoiceeDetails.Created, action.fields[0], invoiceeDetails.CustomerGroupCode, invoiceeDetails.DistributionCode, invoiceeDetails.HasInvoiceFee, invoiceeDetails.Email, invoiceeDetails.EmailAddressInvoice, invoiceeDetails.EInvoiceIdentifier, invoiceeDetails.CurrencyCode, invoiceeDetails.ExclVat, invoiceeDetails.InvoiceSettings, invoiceeDetails.InvoiceType, invoiceeDetails.InvoiceeBatchId, invoiceeDetails.InvoiceeContactReference, invoiceeDetails.InvoiceeNr, invoiceeDetails.ManualDistributionChannel, invoiceeDetails.MonthlyBillingInterval, invoiceeDetails.MortgageBlocked, invoiceeDetails.Name, invoiceeDetails.NoNextInvoice, invoiceeDetails.OrganizationNr, invoiceeDetails.OurReference, invoiceeDetails.PaymentMethod, invoiceeDetails.PaymentState, invoiceeDetails.PaymentTermsFixedDay, invoiceeDetails.PaymentTermsNetDays, invoiceeDetails.Updated, invoiceeDetails.TerminationState)), option), state.InvoiceeDetails), state.InvoiceeFees, state.InvoiceeBlock, state.InvoiceeTerminationState);
        }
        case 3: {
            return new InvoiceeState(state.InvoiceeDetails, state.InvoiceeFees, action.fields[0], state.InvoiceeTerminationState);
        }
        case 4: {
            return new InvoiceeState(state.InvoiceeDetails, state.InvoiceeFees, state.InvoiceeBlock, action.fields[0]);
        }
        default: {
            return new InvoiceeState(action.fields[0], state.InvoiceeFees, state.InvoiceeBlock, state.InvoiceeTerminationState);
        }
    }
}

export function reducer(stateOpt, action) {
    return createReducer("InvoiceeReducer", initState, stateOpt, action, innerReducer);
}

